import { render } from "./PopUpMenuFolder.vue?vue&type=template&id=7bec7dd0"
import script from "./PopUpMenuFolder.vue?vue&type=script&lang=js"
export * from "./PopUpMenuFolder.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__